// extracted by mini-css-extract-plugin
export default {"heroHeader":"heroHeader_P6qJA","heroHeaderContainer":"heroHeaderContainer_sSi0I"};